import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RecoverComponent } from './login/recover/recover.component';
import { ResetPasswordComponent } from './login/recover/reset-password/reset-password.component';
import { WithoutSessionGuard } from '@web-frontend/shared/guards/auth/without-session.guard';
import { ImpersonateComponent } from './impersonate/impersonate.component';
import { OnboardingRedirectGuard } from '@web-frontend/shared/guards/auth/onboarding-redirect.guard';

const internalRoutes = {
  recover: 'recover',
  resetPassword: 'reset-password',
  onboarding: 'onboarding',
  maintenance: 'maintenance',
  impersonate: 'impersonate',
};

export const authRoutes = {
  recover: `/auth/${internalRoutes.recover}`,
  resetPassword: `/auth/${internalRoutes.resetPassword}`,
  onboarding: `/auth/${internalRoutes.onboarding}`,
  impersonate: `/auth/${internalRoutes.impersonate}`,
  login: '/auth/login',
  aiform: '/auth/login/aiform',
  clientRegister:
    '/auth/login/60911eba-984a-45c4-a1be-1e905926d5fa/client-register',
};

const routes: Routes = [
  {
    path: internalRoutes.recover,
    canActivate: [WithoutSessionGuard],
    component: RecoverComponent,
  },
  {
    path: `${internalRoutes.resetPassword}/:token`,
    canActivate: [WithoutSessionGuard],
    component: ResetPasswordComponent,
  },
  {
    path: internalRoutes.impersonate,
    component: ImpersonateComponent,
  },
  {
    path: '',
    canActivate: [WithoutSessionGuard, OnboardingRedirectGuard],
    loadChildren: () =>
      import('../../microfrontends/mf-auth/mf-auth.module').then(
        (m) => m.MfAuthModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  providers: [WithoutSessionGuard, OnboardingRedirectGuard],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
